// textarea 자동 높이 — 내용이 길어지면 스크롤바가 생기는 대신 칸이 늘어난다.
// 저작 칸(상황·지침·루브릭)은 여러 줄을 쓰는 게 정상인데 rows=2~4에 갇혀 있으면
// 쓴 걸 다시 못 읽어서 저작자가 스크롤로 더듬게 된다.
//
//   <textarea class="text-field" rows="3" bind:value={x} use:autoGrow={x} />
//
// 파라미터로 바인딩된 값을 같이 넘기는 이유: 사용자가 타이핑할 때 말고
// 코드가 값을 갈아끼울 때(블록 전환·저장본 로드)도 다시 재야 한다.
// CSS의 min-height / max-height는 그대로 산다 — 여기서는 height만 정하고,
// max-height에 걸리면 그때만 스크롤을 돌려준다.

/** 지금 내용에 딱 맞는 높이로 맞춘다. 아직 화면에 없으면(접힌 카드·닫힌 팝업) 건너뛴다. */
function fit(node) {
	if (!node.isConnected || node.clientWidth === 0) return; // 레이아웃 전 → scrollHeight가 0
	const cs = getComputedStyle(node);
	// scrollHeight = content + padding. border-box면 테두리를 더해야 같은 높이가 된다.
	const extra =
		cs.boxSizing === "border-box"
			? (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.borderBottomWidth) || 0)
			: -((parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0));
	node.style.height = "auto"; // 줄인 경우도 따라가게 먼저 풀어준다
	const next = node.scrollHeight + extra;
	node.style.height = `${next}px`;
	const max = parseFloat(cs.maxHeight);
	node.style.overflowY = Number.isFinite(max) && next > max ? "auto" : "hidden";
}

/** Svelte action. 파라미터는 "다시 재라"는 신호로만 쓴다(값 자체는 안 봄). */
export function autoGrow(node) {
	node.style.resize = "none"; // 높이를 코드가 정하므로 손잡이는 무의미(끌어도 다음 입력에 되돌아감)
	const onInput = () => fit(node);
	node.addEventListener("input", onInput);

	// 접힌 카드/숨은 탭 안에서 mount되면 clientWidth=0이라 못 잰다.
	// 폭이 0 → N으로 바뀌는 순간(= 보이기 시작한 순간)과 패널 폭 변화에만 다시 잰다.
	// height 변화에 반응하면 자기가 부른 리사이즈에 다시 반응해 무한루프가 된다.
	let lastWidth = node.clientWidth;
	const ro =
		typeof ResizeObserver !== "undefined"
			? new ResizeObserver(() => {
					if (node.clientWidth === lastWidth) return;
					lastWidth = node.clientWidth;
					fit(node);
				})
			: null;
	ro?.observe(node);

	fit(node);
	requestAnimationFrame(() => fit(node)); // 스타일 적용 전 mount 대비

	return {
		// bind:value로 값이 갈릴 때. Svelte가 DOM value를 먼저 쓰는지 보장하지 않아 한 틱 미룬다.
		update() {
			queueMicrotask(() => fit(node));
		},
		destroy() {
			node.removeEventListener("input", onInput);
			ro?.disconnect();
		},
	};
}
